import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useRegisterComponent } from '../../../orchestrator';
import { useAppDispatch } from '../../../../stores/redux.store';
import { handleMfaPromoteUserSelection } from '../../../../actions/mfa-promote-actions';
import { useButtonClickedEvent } from '../../../../utilities/analytics/analytics-web-client';
import { usePasskeyEnrollmentTaskSession } from '../usePasskeyEnrollmentTaskSession';
import { pageId } from '../constants';

/**
 * Provides the handler for the "Create a passkey" button.
 * When called, it will trigger a server-driven redirect to the passkey enrollment flow.
 */
export const useCreatePasskey = () => {
  useRegisterComponent(useCreatePasskey.name);

  const dispatch = useAppDispatch();
  const { search } = useLocation();
  const trackPasskeysContinueButtonClicked = useButtonClickedEvent(
    pageId,
    'PasskeysPromoteContinue'
  );
  const { getUrlSearchEntriesForTaskSession } = usePasskeyEnrollmentTaskSession();

  const onCreatePasskeyClicked = useCallback(() => {
    trackPasskeysContinueButtonClicked();
    dispatch(
      handleMfaPromoteUserSelection('edit_passkey', search, {
        additionalSearchParamsEntries: getUrlSearchEntriesForTaskSession(),
      })
    );
  }, [dispatch, search, trackPasskeysContinueButtonClicked, getUrlSearchEntriesForTaskSession]);

  return { onCreatePasskeyClicked };
};
